function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSmooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.9 7.1",
    style: {
      enableBackground: "new 0 0 11.9 7.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4cd964"
    },
    d: "M5.2 6.8c-.3.3-.8.3-1.1 0L.2 3.3c-.3-.3-.2-.7 0-.9.3-.3.8-.3 1.1 0l3.3 3 6-5.2c.3-.3.8-.3 1.1 0 .3.2.3.6.1.9l-.1.1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmooth);
export default __webpack_public_path__ + "static/media/check-smooth.9dedc7f91a1e426c9e5906a11b499222.svg";
export { ForwardRef as ReactComponent };